<template>
  <div class="app-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style lang="less">
@import "./style/variable.less";
@import "./style/font.css";
// 官网
@import url("./assets/font/iconfont-pc.css");
@import url("//at.alicdn.com/t/c/font_4688936_5krkqi13oqk.css");
// 移动适配
@import url("./assets/font/iconfont-mobile.css");

@media screen and(min-width:@sm_min) {
  html,
  body {
    width: 100%;
    height: 100%;
    min-width: 1380px;
    font-family: AlibabaPuHuiTi, "Microsoft Yahei";
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // filter: grayscale(100%);
    // -webkit-filter: gray;
    // filter: gray;
    // -webkit-filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
    // filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
  }

  .app-main {
    width: 100%;
    height: 100%;
  }
}
@media screen and (min-width: @phone) and (max-width: @xs) {
  html,
  body {
    width: 100%;
    height: 100%;
    font-family: AlibabaPuHuiTi, "Microsoft Yahei";
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // filter: grayscale(100%);
    // -webkit-filter: gray;
    // filter: gray;
    // -webkit-filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
    // filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue